export const configuration = {
    ENVIRONMENT: process.env.REACT_APP_ENV,
    CONNECTION_STRING: process.env.REACT_APP_INSTRUMENTATION_KEY
};